const trimTrailingSlashes = (path = '') => path.replace(/\/+$/, '');

export const getAppPath = path => {
  const basename = trimTrailingSlashes(process.env.PUBLIC_URL || '');
  const routePath = path.replace(/^\/+/, '');

  return `${basename}/${routePath}`;
};

export const isCurrentAppPath = path =>
  trimTrailingSlashes(window.location.pathname) ===
  trimTrailingSlashes(getAppPath(path));
